import { Component, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardComponent implements OnInit {
  hasReloaded:boolean = false;

  constructor(
    private cookies:CookieService,
    private renderer:Renderer2,
    private router: Router,) {
    
   }
    
  ngOnInit(): void {
    const currentUrl = this.router.url;
    // if (this.hasReloaded == false) {
    //   sessionStorage.setItem('hasReloaded', 'true');
    //   this.hasReloaded = true;  // Set flag to true
    //   window.location.reload(); // Reload the page
    // }
    if(sessionStorage.getItem('hasReloaded') && currentUrl !== '/'){
      return
    }
    else{
      this.shouldShowPopup();

    }
  }
  
  shouldShowPopup(): boolean {
		if (!this.hasReloaded) {
			this.hasReloaded = true;
			sessionStorage.setItem('hasReloaded', 'true');
      window.location.reload(); 
			return true;
		}
		return false;
	}

  
}
